module.exports = __webpack_public_path__ + "static/media/tag.ab03733a.svg";